// extracted by mini-css-extract-plugin
export default {"forgotPassContainer":"ForgotPassword_forgotPassContainer__hUINJ","resetPassForm":"ForgotPassword_resetPassForm__nwJzj","login":"ForgotPassword_login__0J46p"};